import { ICategory } from "../components/ActionsSelectors/Categories/Category";

export const carouselData: {
  carouselItems: ICategory<HTMLLinkElement>[];
} = {
  carouselItems: [
    {
      id: "1",
      linkParams: { href: "#running" },
      itemName: "running",
      itemMediaData: {
        data: { src: "assets/images/running.jpg" },
      },
      itemDescription: "View 89 products",
    },
    {
      id: "2",
      linkParams: { href: "#football" },
      itemName: "football",
      itemMediaData: {
        data: { src: "assets/images/neutral.jpg" },
      },
      itemDescription: "View 90 products",
    },
    {
      id: "3",
      linkParams: { href: "#outdoor" },
      itemName: "outdoor",
      itemMediaData: {
        data: { src: "assets/images/outdoor.jpg" },
      },
      itemDescription: "View 91 products",
    },
    {
      id: "4",
      linkParams: { href: "#sneakers" },
      itemName: "sneakers",
      itemMediaData: {
        data: { src: "assets/images/sneakers.jpg" },
      },
      itemDescription: "View 92 products",
    },
    {
      id: "5",
      linkParams: { href: "#lightweight-trainers" },
      itemName: "lightweight-trainers",
      itemMediaData: {
        data: { src: "assets/images/lightweight-trainers.jpg" },
      },
      itemDescription: "View 93 products",
    },
  ],
};
